import "./css/SectionMessage.css";

// COMPONENTS
import { TextInput } from "../../../../components/Inputs";
import { ButtonLanding } from "../../../../components/Buttons";

function SectionMessage({ illustration }) {
  return (
    <section className="section-message">
      <div className="message-container landing-container">
        <div className="left">
          <h2>Message us</h2>
          <p>If you want to send us message, feel free to sent us.</p>
          <div className="message-svg">{illustration}</div>
        </div>
        <div className="right">
          <form action="" className="form">
            <TextInput label={"Name"} transparent />
            <TextInput label={"Email"} transparent />
            <TextInput type="textarea" label={"Message"} transparent />
            <ButtonLanding name={"Send"} type="submit" />
          </form>
        </div>
      </div>
    </section>
  );
}

export default SectionMessage;
